import { render, staticRenderFns } from "./HRegBasic.vue?vue&type=template&id=40bb89e4&scoped=true"
import script from "./HRegBasic.vue?vue&type=script&lang=js"
export * from "./HRegBasic.vue?vue&type=script&lang=js"
import style0 from "./HRegBasic.vue?vue&type=style&index=0&id=40bb89e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb89e4",
  null
  
)

export default component.exports